/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/
// start loader
// function loader_hit(){
//     $(".loaderChekout").show();
//     $(".loaderChekout-overlay").show(); 
//   }

$( document ).ready(function() {
    if($(window).width() <= 749){
  $('.product_tab_wrapper').html('');
    }
  //start loader
    $("#checkout").click(function(e){
      e.preventDefault();
      $(".Main_container").css("display","block");
      window.location.href="/checkout??step=contact_information";
  });
  // end loader
 // start reviews code
  const myBody = document.body;
  if( myBody.classList.contains("template-product"))
  {
      $(".jdgm-prev-badge").click(function () {
   window.scrollBy({
    top: 750,
    left: 0,
    behavior : "smooth"
})
   $(".cst_review").trigger('click'); 
  });
  }
   $(".mobile_review_product").click(function () {
     window.scrollBy({
    top: 450,
    left: 0,
    behavior : "smooth"
})
   $(".reviews_acc").trigger('click'); 
  });
 // end here
  
 });


(function($) {
  $('.drawer__closed a').click(function(e){
    $('button[data-drawer-toggle="hamburger"]').trigger('click');
     e.preventDefault();
  });

  $('body').on('click',' .slideup .caps',function(){
    // alert("add1")
Add_to_cart_price =$(this).parents('.product-information').find(".new-price").text().replace('₹','');
 
  gtag('event', 'add-to-bag', {
      'send_to': 'AW-1008983695/AtxzCK3svIwYEI-9j-ED',
      'value': Add_to_cart_price,
      'currency': 'INR',
      'transaction_id': ''
  });
  //   gtag('event', 'add-to-bag', {
  //     'send_to': 'AW-11112347865/cA5wCJ_-55AYENnx47Ip',
  //     'value': Add_to_cart_price,
  //     'currency': 'INR',
  //     'transaction_id': ''
  // });
  //     gtag('event', 'conversion', {
  //     'send_to': 'AW-10869353894/0ZaNCO6Ur4oYEKbb9L4o',
  //     'value': Add_to_cart_price,
  //     'currency': 'INR',
  //     // 'event_callback': callback
  // });

    var product_category = $(this).attr('data-product-type');
    var product_id  = $(this).attr('data-product-id');
    var prod_varid  = $(this).attr('data-var');
    var product_title  = $(this).attr('data-product-name');
    var product_price = $(this).attr('data-price')/100;
      // fb_Atc(product_category,product_id,prod_varid,product_title,product_price);
  

    });

  $('body').on('click',' .product__submit__buttons .product__submit__add',function(){
    // alert("add2")
Product_page_Add_to_cart_price =$(this).parents('.form__inner__wrapper').find("#product__price--sale").text().replace('₹','');
   
      gtag('event', 'conversion', {
      'send_to': 'AW-10869353894/0ZaNCO6Ur4oYEKbb9L4o',
      'value': Product_page_Add_to_cart_price,
      'currency': 'INR',
      // 'event_callback': callback
  });
  //   gtag('event', 'conversion', {
  //     'send_to': 'AW-11112347865/iU-7CJz-55AYENnx47Ip',
  //     'value': Product_page_Add_to_cart_price,
  //     'currency': 'INR',
  //     // 'event_callback': callback
  // });

    });
  $('.faq-acc-heading').click(function(e) {   
  	e.preventDefault();
    let $this = $(this);
    if ($this.hasClass('show-acc')) {
        $this.removeClass('show-acc');
        $this.next().slideUp(350);
    } else {
        $this.parent().parent().find('.faq-acc-heading').removeClass('show-acc');
        $this.parent().parent().find('.faq-acc-content').slideUp(350);
         $this.addClass('show-acc');
        $this.next().slideDown(350);
        $this.next().css('display','block');
    }
});
  
   if($(window).width() <= 749){
    $('body').on('click','.nav_title',function(){
    let $this = $(this);
    if ($this.hasClass('show-acc')) {
        $this.removeClass('show-acc');
        $this.next().slideUp(350);
    } else {
        $this.parent().parent().find('.nav_title').removeClass('show-acc');
        $this.parent().parent().find('.nav_content').slideUp(350);
        $this.toggleClass('show-acc');
        $this.next().slideToggle(350);
    }
    });
  }
  setTimeout(function(){
  if(($(window).width() > 1024)){
    //       alert();
    $('.product-page .product__thumbs--square .thumbs-holder').slick({
      infinite: false,
      autoplay: false,
      slidesToShow: 6,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      prevArrow: '<button class="slick-prev"><i class="fa fa-angle-left"></i></button>',
      nextArrow: '<button class="slick-next"><i class="fa fa-angle-right"></i></button>'
    });
  } else{
    $('.product-page .product__thumbs--square .thumbs-holder').slick({
      infinite: false,
      autoplay: false,
      slidesToShow:4,
      slidesToScroll: 1, 
      arrows: true,
      dots: false,
      prevArrow: '<button class="slick-prev"><i class="fa fa-angle-left"></i></button>',
      nextArrow: '<button class="slick-next"><i class="fa fa-angle-right"></i></button>'
    });
  }
 },1000); 
  
  
  $('body').on('click','.close__announcement',function(){
  $('div#shopify-section-announcement').remove();
   localStorage.setItem('announcement',true);  
  });
  if(localStorage.getItem('announcement')){
   $('div#shopify-section-announcement').remove();
  }
  
  // $('body').on('click','.review__product__main',function(){
  // var container = $('.template-product');
  // var scrollTo = $('.reviews-holder');
  // var position = scrollTo.offset().top
		// 		- container.offset().top
		// 		+ container.scrollTop()-180;
  //    $('body,html').animate({scrollTop:position}, 600);
  // });

  // document.querySelector(".review__product__main").addEventListener('click',function()
  //   {
  //     var review_btn = document.querySelector(".cst_review");
  //     window.scrollBy(0,500);
  //     review_btn.click();
  //     var inner_width =  window.innerWidth;
  //     if(inner_width <= 768)
  //     {
  //       let =  mob_review_open = document.getElementsByClassName("accordion_outer")[1];
  //       let mob_review_open_1 =  mob_review_open.firstElementChild;
  //       // console.log(mob_review_open_1 );
  //       window.scrollBy(0,500);
  //       mob_review_open_1.click();
  //     } 
  // })                                                               
  
 // start share icon on pdp page 
  $('.social_mobile_icon button').click(function(){
  $('.social__icons_mobile').toggle();
  });
  // end  share icon on pdp page
  // $('body').on('click','.checkout__top',function(){
  //   $('button[name="checkout"]').click();
  // });
  
  $('.cart-drawer-recommended').slick({
  slidesToShow: 2,
  slidesToScroll: 2,
  arrows: false,
  dots:true
  });
  
  // $('.payment_details').click(function(){
  //   // alert("jjj")
  // $('.payment_inner').slideToggle();
  // });

   // start bottom design offer
   $(document).ready(function(){
    $("body").click(function(event){
      $("#up_icon").click(function(){
        $(".payment_inner").show("blind");
        $("#up_icon").hide();
        $("#down_icon").show();

      });
      $("#down_icon").click(function(){
        $(".payment_inner").hide("blind");
        $("#down_icon").hide();
        $("#up_icon").show();
      });
    });
  });
  
  //end here
  
  $('.cart_view').click(function(){
  $('.cart-dropdown').toggleClass('is-open');
  });
 if($(window).width() < 769){
  $('.search-popdown').addClass('show_search');
   $(window).scroll(function() {
  $('.mobile-bottom-nav').stop(true, true).hide().fadeIn('fast');
});
  }
  /*________________________Variant wise thumbnail_________________________*/
  if($('.product__selectors').length > 0){
  var swatchAlt= $('.product__selectors input:checked').val().toLowerCase().replace(/ /g, '');
    if(swatchAlt!=undefined){
    setTimeout(function(){
    thumbImages(swatchAlt);
      },1000);
  }
  }
  function thumbImages(swatchAlt){
//       alert(swatchAlt);
    $('.single-image-selected').unwrap();
    $('.main-image-selected').unwrap();
    $('.thumbs-holder .thumb ').each(function(){
      var media_alt =$(this).attr('media-alt').toLowerCase().replace(/ /g, '');
//       alert(media_alt+'=='+swatchAlt);
      if(media_alt==swatchAlt){
        $(this).show();
        $(this).addClass('single-image-selected');
      }
      else{
        $(this).hide();
        $(this).removeClass('single-image-selected');
      }
    });
    $('.single-image-selected').wrapAll('<div class="thumb_main"></div>');
    mainthumbslider();
  }
   function mainthumbslider(){
    //   alert('kk');
    if(($(window).width() > 1008)){
      //       alert();
      $('.thumb_main').slick({
        infinite: false,
        autoplay: false,
        slidesToShow: 6,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        prevArrow: '<button class="slick-prev"><i class="fa fa-angle-left"></i></button>',
      nextArrow: '<button class="slick-next"><i class="fa fa-angle-right"></i></button>'
      });
    } else{
      $('.thumb_main').slick({
        infinite: false,
        autoplay: false,
        slidesToShow: 4,
        slidesToScroll: 1, 
        arrows: true,
        dots: false,
        prevArrow: '<button class="slick-prev"><i class="fa fa-angle-left"></i></button>',
      nextArrow: '<button class="slick-next"><i class="fa fa-angle-right"></i></button>'
      });
      
    }
    setTimeout(function(){
     $('.thumb_main').find('a').get(0).click();
      },100);
  }
  $('body').on('click','.product__selectors input',function(){
    var swatchAlt= $(this).val().toLowerCase().replace(/ /g, '');
    $('.thumb_main').slick('unslick');
    thumbImages(swatchAlt);
  });
  /*________________________Variant wise thumbnail_________________________*/
 function gtag_report_conversion(url,price) {
      // var callback = function () {
      //   if (typeof(url) != 'undefined') {
      //     window.location = url;
      //   }
      // };
        // alert('begin_checkout');
      gtag('event', 'begin_checkout', {
          'send_to': 'AW-10975469864/xQQxCLD5ptkDEKjCwfEo',
          'value': price,
          'currency': 'INR',
          'transaction_id': ''
      });
      return false;
    }
  $('body').on('click','.cart__foot-inner .cart__checkout',function(){
    let totalPrice= $(this).parents('.cart__foot-inner').find('.payment_details .cart__total__money').text().replace ('₹','');
    let totalPrice_num = totalPrice.replace (',','');
    let DataUrl = $(this).attr('data-url');
   
    gtag_report_conversion(DataUrl,totalPrice_num);
  });
   $('body').on('click','.botton_sign_in a',function(e) {
    // e.preventDefault();
    // $('.header__mobile__button.account_link_header a').click();
  });
})(jQuery);
// ------------cart-bag popup--------------
 $('body').on('click','.close-review-popup ',function(e){
   $('.modal-review-poup').hide();
  });
$('body').on('click','.cart__icon__content',function(e){
   $('.cart__popup_main').hide();
  });
//--------------end------------

 /***************Account page review popup***********/   
  $('body').on('click','.review_popup__form',function(e){
    var i = $(this).attr('pro_handle');
    fetch('/products/'+ i +'?view=review', {
      credentials: 'same-origin',
      method: 'GET'
    }).then(function (content) {    
      content.text().then(function (html) {
        // console.log(html);
         $('.review-cancellation-form').html(html); 
        //   var container = document.createElement('div');
        // container.innerHTML = html;
        setTimeout(function(){
        $('.modal-review-poup').show();
          }, 200);
      });
    });
    e.preventDefault();
   });

  $('body').on('click','.close-review-popup ',function(e){
   $('.modal-review-poup').hide();
    $('.review-cancellation-form').html('');
  });

//**********end*******************

//*****************************************Accessibility*******************************
let navvaria=document.querySelectorAll(".navvaria");
navvaria.forEach((item,index)=>{

  item.parentElement.setAttribute("aria-label",`${item.textContent} ${index+1} of ${navvaria.length}`)
})

const parentEle =document.querySelector('.Hair').parentElement.parentElement;
parentEle.querySelectorAll(".navsubchild_haircare").forEach((item)=>{
 item.classList.add("mobsub")
})
  let mobsub=document.querySelectorAll(".mobsub");
mobsub.forEach((item,index)=>{
  item.setAttribute("aria-label",`${item.innerText} ${index+1} of ${mobsub.length}`)
})

const parentElebody =document.querySelector('.Body').parentElement.parentElement;
parentElebody.querySelectorAll(".navsubchild_haircare").forEach((item)=>{
  item.classList.add("mobsubbody")
})
let mobsubbody=document.querySelectorAll(".mobsubbody");
mobsubbody.forEach((item,index)=>{
  item.setAttribute("aria-label",`${item.innerText} ${index+1} of ${mobsubbody.length}`)
})

const parentEleConcern =document.querySelector('.Concern').parentElement.parentElement;
parentEleConcern.querySelectorAll(".navsubchild_haircare").forEach((item)=>{
  item.classList.add("mobsubConcern")
})
let mobsubConcern=document.querySelectorAll(".mobsubConcern");
mobsubConcern.forEach((item,index)=>{
  item.setAttribute("aria-label",`${item.innerText} ${index+1} of ${mobsubConcern.length}`)
})

 //for desktop submenu********
let dsk_body=document.querySelector(".dsk_Body").parentElement
dsk_body.querySelectorAll(".navlink--child").forEach((item,index)=>{
  item.classList.add("bodysub")
})
let dsk_Shop =document.querySelector(".dsk_Shop").parentElement
dsk_Shop.querySelectorAll(".navlink--child").forEach((item)=>{
  item.classList.add("shop_sub")
})
let bodysub=document.querySelectorAll(".bodysub");
bodysub.forEach((item,index)=>{
  item.setAttribute("aria-label",`${item.textContent} ${index+1} of ${bodysub.length}`)
})
let dsk_Hair=document.querySelector(".dsk_Hair").parentElement
dsk_Hair.querySelectorAll(".navlink--child").forEach((item,index)=>{
  item.classList.add("hairsub")
})
let hairsub=document.querySelectorAll(".hairsub");
hairsub.forEach((item,index)=>{
  item.setAttribute("aria-label",`${item.textContent} ${index+1} of ${hairsub.length}`)
})
let shop_sub=document.querySelectorAll(".shop_sub");
shop_sub.forEach((item,index)=>{
  item.setAttribute("aria-label",`${item.textContent} ${index+1} of ${shop_sub.length}`)
})

 let menu__it=document.querySelectorAll('.child');
menu__it.forEach((item)=>{
  if(item.classList.contains("main-menu--active")){
      item.style.backgroundColor="#f0dfbeab"
    item.style.padding="5px 10px 10px 4px"
    item.firstElementChild.setAttribute("aria-current","page")
    
  }
})

//***********Accessibility***********************
var menuItems = document.querySelectorAll('.menu__item');

menuItems.forEach((item) => {
  const toggleDropdown = () => {
    if (item.classList.contains("dropdownVisible")) {
      item.classList.remove("dropdownVisible");
      item.firstElementChild.setAttribute("aria-expanded", "false");
      document.querySelector(".dsk_Men")?.removeAttribute("aria-expanded");
      document.querySelector(".dsk_Buy")?.removeAttribute("aria-expanded");
      document.querySelector(".dsk_#StopTheBeautyTest")?.removeAttribute("aria-expanded");
    } else {
      document.querySelectorAll(".menu__item").forEach((menuItem) => {
        menuItem.classList.remove("dropdownVisible");
        menuItem.firstElementChild.setAttribute("aria-expanded", "false");
      });
      item.classList.add("dropdownVisible");
      item.firstElementChild.setAttribute("aria-expanded", "true");
    }
    const headerDropdown = item.querySelector(".header__dropdown");
    headerDropdown.classList.toggle("is-visiblee");
  };

  // item.addEventListener("click", toggleDropdown);
  item.addEventListener("mouseenter", toggleDropdown);
  item.addEventListener("mouseleave", toggleDropdown);
});

document.addEventListener("keydown", function(e) {
  if (e.key === "Escape") {
    menuItems.forEach((item) => {
      item.classList.remove("dropdownVisible");
    });
    document.querySelectorAll(".navlink--toplevel").forEach((navLink) => {
      navLink.setAttribute("aria-expanded", "false");
    });
    document.querySelector(".dsk_Men")?.removeAttribute("aria-expanded");
    document.querySelector(".dsk_Buy")?.removeAttribute("aria-expanded");
    document.querySelectorAll(".navlink--toplevel")[5]?.removeAttribute("aria-expanded");
  }
});
//**************submenu focus******

document.addEventListener("keydown", function (e) {
  if (e.key === "Escape") {
    document.querySelectorAll(".hairsub").forEach((item) => {
      if (item === document.activeElement) {
        let hairsub = document.querySelector(".dsk_Hair");
        hairsub.focus();
      }
    });
  }
});
document.addEventListener("keydown", function (e) {
  if (e.key === "Escape") {
    document.querySelectorAll(".bodysub").forEach((item) => {
      if (item === document.activeElement) {
        let bodysub = document.querySelector(".dsk_Body");
        bodysub.focus();
      }
    });
  }
});
document.addEventListener("keydown", function (e) {
  if (e.key === "Escape") {
    document.querySelectorAll(".shop_sub").forEach((item) => {
      if (item === document.activeElement) {
        let shopsub = document.querySelector(".dsk_Shop");
        shopsub.focus();
      }
    });
  }
});

let navchild=document.querySelectorAll('.navlink--child');
navchild.forEach((item)=>{
  if(item.classList.contains("main-menu--active")){
    item.style.backgroundColor="#f0dfbeab"
    item.style.padding="5px 10px 10px 4px"
    item.parentElement.parentElement.parentElement.parentElement.style.backgroundColor="#f0dfbeab";
    // item.setAttribute("aria-expanded","true")
    item.setAttribute("aria-current","page")
    
  }
})

document.querySelector(".drawer__closed").previousElementSibling.remove()
document.querySelector(".drawer__closed").children[0].remove()
document.querySelectorAll(".primary_menu .navlink--toplevel").forEach((item)=>{
  item.classList.add("primarymainn")
})
 let navv=document.querySelectorAll(".primarymainn")
   navv.forEach((item,index)=>{
     
     item.setAttribute("aria-label",`${item.innerText} ${index+1} of ${navv.length}`)
     
  })
if(document.querySelector(".dsk_Buy")){
document.querySelector('.dsk_Buy').setAttribute("aria-label",`Buy 3 @ 1249 1 of 2`)
}
let stopthebeauty=document.querySelectorAll('.navlink--toplevel')[5];
if(stopthebeauty){
 stopthebeauty.setAttribute("aria-label",`#StopTheBeautyTest 2 of 2`) 
}


var passwordField = document.querySelector('.user_password');
var user_first_name = document.querySelector('.user_first_name');
var user_last_name = document.querySelector('.user_last_name');
var user_email = document.querySelector('.user_email');
var newElement = document.createElement('span');
var buttonFiled = document.querySelector('#create_customer .btn');
var checkBox = document.getElementById("myCheckbox_reg");
newElement.classList.add("errorPass");
// var afterElement = passwordField?.after(newElement);
  var afterElement = document.querySelector('.errormsg');
function updateSubmitButton() {
  var tgtfirst = user_first_name?.value.trim();
  var tgtlast = user_last_name?.value.trim();
  var userEmail = user_email?.value.trim();
  var passwordValue = passwordField?.value.trim();
  if (tgtfirst && tgtlast && userEmail && passwordValue && checkBox?.checked === true) {
    // let passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@.#$!%*?&])[A-Za-z\d@.#$!%*?&]{8,15}$/;
     let passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%&])[A-Za-z\d@#$%&]{8,15}$/;
      // let passwordRegex = /^[a-zA-Z0-9@#$%&*]{8,15}$/;
    // console.log(passwordValue,"passwordValue>>>>.")

    if (passwordRegex.test(passwordValue)) {
    // console.log(passwordValue,"passwordField")  
      afterElement.textContent = 'Valid password';
      afterElement.style.color = 'green';
      buttonFiled.setAttribute('type', 'submit');
    } else {
      afterElement.textContent = 'Enter a valid password: minimum 8 characters, 1 uppercase, 1 lowercase, 1 number, 1 special character [ @ # $ % & * ].';
      afterElement.style.color = 'red';
      buttonFiled.setAttribute('type', 'button');
    }
  } else {
    afterElement.textContent = 'Please fill in all fields.';
    afterElement.style.color = 'red';
    buttonFiled?.setAttribute('type', 'button');
  }
}

if (checkBox) {
  checkBox.addEventListener('input', updateSubmitButton);
}

user_first_name?.addEventListener('input', updateSubmitButton);
user_last_name?.addEventListener('input', updateSubmitButton);
user_email?.addEventListener('input', updateSubmitButton);
passwordField?.addEventListener('input', updateSubmitButton);

// Add event listener to the "add_value" button
var addButton = document.getElementById('add_value');
if (addButton) {
  addButton.addEventListener('click', validateFields);
}

function validateFields() {
  var tgtfirst = user_first_name?.value.trim();
  var tgtlast = user_last_name?.value.trim();
  var userEmail = user_email?.value.trim();
  var passwordValue = passwordField?.value.trim();

  // Check each input field and display an error message if needed
  if (!tgtfirst) {
    displayError(user_first_name, 'First name is required.');
  } else {
    clearError(user_first_name);
  }

  if (!tgtlast) {
    displayError(user_last_name, 'Last name is required.');
  } else {
    clearError(user_last_name);
  }

  if (!userEmail) {
    displayError(user_email, 'Email is required.');
  } else {
    clearError(user_email);
  }

  if (!passwordValue) {
    displayError(passwordField, 'Password is required.');
  } else {
    clearError(passwordField);
  }

  // Check the checkbox
  if (!checkBox?.checked) {
    displayError(checkBox, 'Please accept the terms.');
  } else {
    clearError(checkBox);
  }

  // Call updateSubmitButton after validating fields
  updateSubmitButton();
}

function displayError(element, message) {
  // Display error message for the specified element
  var nextSibling = element?.nextElementSibling;
  if (nextSibling) {
    var errorSpan = nextSibling.querySelector('.errorPass');
    if (errorSpan) {
      errorSpan.textContent = message;
    }
  }
}

function clearError(element) {
  // Clear error message for the specified element
  var nextSibling = element?.nextElementSibling;
  if (nextSibling) {
    var errorSpan = nextSibling.querySelector('.errorPass');
    if (errorSpan) {
      errorSpan.textContent = '';
    }
  }
}


var setPassword = document.querySelector('#customer_password');
var confirmPassword = document.querySelector('#customer_password_confirmation');
var newElement1 = document.createElement('span');
var buttonField = document.querySelector('#ResetPassword .btn');
newElement1.classList.add("errorPass1");
setPassword?.after(newElement1);
function updateSetSubmitButton() {
  var tgtpasswordField = setPassword.value.trim();
  var tgtconfirmPassword = confirmPassword.value.trim();
  if (tgtpasswordField && tgtconfirmPassword) {
    let passwordRegex1 = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%&])[A-Za-z\d@#$%&]{8,15}$/;
    // let passwordRegex1 = /^[a-zA-Z0-9@#$%&*]{8,15}$/;
          // console.log(tgtpasswordField,"tgtpasswordField>>>>")
    if (passwordRegex1.test(tgtpasswordField)) {
      newElement1.textContent = 'Valid password';
      newElement1.style.color = 'green';
      buttonField.setAttribute('type', 'submit');
    } else {
      newElement1.textContent = 'Enter a valid password: minimum 8 characters, 1 uppercase, 1 lowercase, 1 number, 1 special character [ @ # $ % & ].';
      newElement1.style.color = 'red';
      buttonField.setAttribute('type', 'button');
    }
  }
}
if(setPassword){
setPassword.addEventListener('input', updateSetSubmitButton);
}
if(confirmPassword){
confirmPassword.addEventListener('input', updateSetSubmitButton);
}

//--------- read more on collection/product content------------
window.addEventListener('DOMContentLoaded', function() {
// if(document.querySelectorAll('.coll_readmore').length != 0){
//   document.querySelector('.coll_readmore').addEventListener('click',function (event) {
//     event.preventDefault();
//     var readMoreMain = this.closest('.content_in_footer').querySelector('.coll_readMoreMain');
//     var readLess = this.closest('.content_in_footer').querySelector('.coll_readLess');
//     var readMore = this.closest('.content_in_footer').querySelector('.coll_readMore');
//     if(readMoreMain && readLess) {
//       readMoreMain.classList.remove('fixed_read_more_truncate');
//       readLess.classList.remove('d_none');
//       readMore.classList.add('d_none')
//     }
//   });
//   document.querySelector('.coll_readless').addEventListener('click',function (event) {
//     event.preventDefault();
//     var readMoreMain = this.closest('.content_in_footer').querySelector('.coll_readMoreMain');
//     var readLess = this.closest('.content_in_footer').querySelector('.coll_readLess');
//     var readMore = this.closest('.content_in_footer').querySelector('.coll_readMore');
//     if(readMoreMain) {
//       readMoreMain.classList.add('fixed_read_more_truncate');
//       readLess.classList.add('d_none');
//       readMore.classList.remove('d_none')
//     }
//   });
// }
  // for PDP read more button
  if(document.querySelectorAll('.readmore').length > 0){
  document.querySelector('.readmore').addEventListener('click',function (event) {
    event.preventDefault();
    var descriptionShort = document.querySelector('.product-description-short');
    descriptionShort.style.display = 'none';
    var descriptionFull = document.querySelector('.product-description-full');
    descriptionFull.style.display = 'block';
    return false;
  });
  document.querySelector('.readless').addEventListener('click',function (event) {
    event.preventDefault();
    var descriptionShort = document.querySelector('.product-description-short');
    descriptionShort.style.display = 'block';
    var descriptionFull = document.querySelector('.product-description-full');
    descriptionFull.style.display = 'none';
    // window.scrollTo({top: 10, behavior: 'smooth'});
  });
}
});
//--------- end read more on collection/product content------------
